/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'retour',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'fermer',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Références',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Actions',
  'ai-smart-button.ai-actions.conversation-starters.loading.text':
    'Chargement des prompts pour engager la conversation...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Demandez à Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Envoyer un commentaire',
  'ai-smart-button.ai-actions.help.section.text': 'Aide',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Lien',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Mention',
  'ai-smart-button.ai-actions.input.placeholder': 'Écrivez ce dont vous avez besoin',
  'ai-smart-button.ai-actions.input.send-button-label': 'Envoyer',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BÊTA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOUVEAU',
  'ai-smart-button.ai-actions.no-results-heading': 'Demandez à Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Envoyez votre prompt à Rovo pour lancer une conversation.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Ajouter une icône',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': "Icône d'agent",
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "Icône d'automatisation",
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatisations',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Parcourir les agents',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Créer un agent',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Créer une automatisation',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': "Plus d'informations sur les agents Rovo",
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'Comment utiliser les agents Rovo dans mon espace Confluence ?',
  'ai-smart-button.ai-actions.static-fallback-1': "Qu'est-ce que Rovo Chat ?",
  'ai-smart-button.ai-actions.static-fallback-2': 'Aidez-moi à faire mes premiers pas avec Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Comment puis-je vous aider ?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Bonjour {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Ignorer',
  'ai-smart-button.feedback-action.ask-question-option': 'Poser une question',
  'ai-smart-button.feedback-action.can-contact-message':
    "Oui, les équipes {product} peuvent me contacter pour en savoir plus sur mon expérience afin d'améliorer les produits et services Atlassian. J'ai pris connaissance de la {privacyPolicy}",
  'ai-smart-button.feedback-action.can-contact-message-appify':
    "Oui, les équipes {product} peuvent me contacter pour en savoir plus sur mon expérience afin d'améliorer les apps et services Atlassian. J'ai pris connaissance de la {privacyPolicy}",
  'ai-smart-button.feedback-action.cancel-button-label': 'Annuler',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Choisissez un élément',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Décrivez le bug ou le problème',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Dites-nous tout',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Que souhaitez-vous savoir ?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dites-nous ce que vous aimeriez améliorer',
  'ai-smart-button.feedback-action.leave-comment-option': 'Laisser un commentaire',
  'ai-smart-button.feedback-action.privacy-policy-link': 'Politique de confidentialité {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Signaler un bug',
  'ai-smart-button.feedback-action.research-participation-message': "J'aimerais participer à la recherche produit",
  'ai-smart-button.feedback-action.select-feedback-heading': 'Sélectionnez le sujet de votre feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Envoyer des commentaires',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Suggérer une amélioration',
  'ai-smart-button.feedback-action.title': 'Envoyer un commentaire',
  'ai-smart-button.feedback-item.icon-label': 'Icône de feedback',
  'ai-smart-button.reference.close-button-label': 'Fermer',
  'ai-smart-button.tooltip.label': "Demander à l'IA Rovo",
  'quick-summary.feedback.summary.placeholder':
    'À quels niveaux Atlassian Intelligence est-il performant ? Que pourrions-nous améliorer ?',
  'quick-summary.feedback.title': 'Aidez-nous à améliorer Atlassian Intelligence',
};
